import React, { useEffect } from 'react';
import { FixedSizeList as List, ListChildComponentProps } from 'react-window';
import InfiniteLoader from 'react-window-infinite-loader';
import CenteredSpinner from '../../components/loading-indicators/centered-spinner';
import { MessageListItem } from '../../logic/graphql/types/types';
import MessageCard from './message-card';

const MessageInfiniteList = (props: {
  hasNextPage: boolean;
  isNextPageLoading: boolean;
  items: MessageListItem[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  loadNextPage: (startIndex: number, stopIndex: number) => Promise<any> | null;
  handleMessageClick: (message: MessageListItem) => void;
  selectedMessage?: MessageListItem;
}): JSX.Element => {
  const {
    hasNextPage,
    isNextPageLoading,
    items,
    loadNextPage,
    handleMessageClick,
    selectedMessage,
  } = props;

  // If there are more items to be loaded then add an extra row to hold a loading indicator.
  const itemCount = hasNextPage ? items.length + 1 : items.length;

  // Only load 1 page of items at a time.
  // Pass an empty callback to InfiniteLoader in case it asks us to load more than once.
  const loadMoreItems = isNextPageLoading
    ? () => {
        return null;
      }
    : loadNextPage;

  // Every row is loaded except for our loading indicator row.
  const isItemLoaded = (index: number): boolean => !hasNextPage || index < items.length;

  // Render an item or a loading indicator.
  const Item = (props: ListChildComponentProps): JSX.Element => {
    // eslint-disable-next-line react/prop-types
    const { index, style } = props;
    useEffect(() => {
      if (items[index]) {
        if (items[index].unread) {
          // handleReadClick(items[index]);
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!isItemLoaded(index)) {
      // content = 'Loading...';
      return <CenteredSpinner style={style} />;
    } else {
      return (
        <div style={style}>
          <MessageCard
            message={items[index]}
            onClick={handleMessageClick}
            current={selectedMessage && selectedMessage.id === items[index].id}
          />
        </div>
      );
    }
  };

  return (
    <InfiniteLoader
      isItemLoaded={isItemLoaded}
      itemCount={itemCount}
      loadMoreItems={loadMoreItems}
      threshold={1}
      minimumBatchSize={10}
    >
      {({ onItemsRendered, ref }) => (
        <List
          className="List"
          height={window.innerHeight - 220}
          itemCount={itemCount}
          itemSize={142}
          onItemsRendered={onItemsRendered}
          ref={ref}
          width={'100%'}
          style={{ overflowY: 'scroll' }}
        >
          {Item}
        </List>
      )}
    </InfiniteLoader>
  );
};

export default MessageInfiniteList;
